export default function Concepto() {
  return (
    <div className="concepto-section" id="concepto">
      <div className="concepto-inner" data-stagger="100">
        <div className="section-label r" style={{ display: 'inline-block', marginBottom: 20 }}>
          El concepto
        </div>
        <p className="concepto-quote r">
          “La educación que el sistema olvidó,
          <br />
          <em>diseñada para el mundo real</em>”
        </p>
        <p className="concepto-body r">
          Random College nace para llenar el vacío que deja la educación tradicional. Aquí no hay
          títulos que enmarcar — hay habilidades que te hacen ganar dinero, construir negocios y
          vivir con libertad.
        </p>
        <div className="concepto-stats r">
          <Stat num="500" sup="+" label="Alumnos activos" />
          <div className="stat-divider" />
          <Stat num="6" label="Módulos prácticos" />
          <div className="stat-divider" />
          <Stat num="24" sup="/7" label="Comunidad viva" />
          <div className="stat-divider" />
          <Stat num="0" label="Títulos inútiles" />
        </div>
      </div>
    </div>
  );
}

function Stat({ num, sup, label }) {
  return (
    <div className="stat-item">
      <div className="stat-num">
        {num}
        {sup && <span>{sup}</span>}
      </div>
      <div className="stat-label">{label}</div>
    </div>
  );
}
